import { render, staticRenderFns } from "./QuestionFormList.vue?vue&type=template&id=c8b877d2&scoped=true"
import script from "./QuestionFormList.vue?vue&type=script&lang=js"
export * from "./QuestionFormList.vue?vue&type=script&lang=js"
import style0 from "./QuestionFormList.vue?vue&type=style&index=0&id=c8b877d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8b877d2",
  null
  
)

export default component.exports